import Link from "next/link"
import Image from "components/Image"
import richText from "utilities/richText"
import { getStoryblokLink } from "utilities/getStoryblokLink"

export default function IconCard({ blok }) {
  return blok.link && blok.link.url ? (
    <Link href={getStoryblokLink(blok.link)}>
      <div className="rounded-4xl w-full max-w-prose mx-auto shadow-icon-card bg-white p-5 flex items-center gap-4 hover:scale-105 transition-all">
        <Image
          unoptimized
          className="h-auto w-24 aspect-square shrink-0"
          width={95}
          height={95}
          src={blok.icon.filename}
          alt={`${blok.heading} Icon`}
        />
        <div>
          <h3 className="uppercase tracking-wider mb-1">{blok.heading}</h3>
          <div className="text-charcoal">{richText(blok.content)}</div>
        </div>
      </div>
    </Link>
  ) : (
    <div className="rounded-4xl w-full max-w-prose mx-auto shadow-icon-card bg-white p-5 flex items-center gap-4">
      <Image
        unoptimized
        className="h-auto w-24 aspect-square shrink-0"
        width={95}
        height={95}
        src={blok.icon.filename}
        alt={`${blok.heading} Icon`}
      />
      <div>
        <h3 className="uppercase tracking-wider mb-1">{blok.heading}</h3>
        <div className="text-charcoal">{richText(blok.content)}</div>
      </div>
    </div>
  )
}
